export * from "ce/reducers/uiReducers";
import { modulesReducerObject as CE_modulesReducerObject } from "ce/reducers/modulesReducers";
import { combineReducers } from "redux";

const modulesReducer = combineReducers({ ...CE_modulesReducerObject });

export default modulesReducer;
